import axios from "axios"

export function getDealerRecallList (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(`/distributor/admin/api/v1/dealers/${parameters.id}/recall`, {
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      order_by: parameters.order_by,
      filter: {
        search: parameters.filter.search,
        from_date: parameters.filter.from_date,
        to_date: parameters.filter.to_date,
        recall_from: parameters.filter.recall_from,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}